import logger from "@/utils/logger";

export function writeVideoShareUrl(params: {
  videoId: string;
  sectionId: string;
  videoName?: string | null;
  locationTag: string;
}) {
  const { videoId, sectionId, videoName, locationTag } = params;

  try {
    const url = new URL(window.location.href);
    url.searchParams.set("videoId", videoId);
    url.searchParams.set("sectionId", sectionId);

    const trimmedName = (videoName ?? "").trim();
    if (trimmedName) {
      url.searchParams.set("videoName", trimmedName);
    } else {
      url.searchParams.delete("videoName");
    }

    // Deep link uses query params only; avoid hashes derived from embed URLs.
    url.hash = "";

    window.history.replaceState(null, "", url.toString());
  } catch (error) {
    logger.error(error, {
      location: locationTag,
    });
  }
}
